'use es6';

import { OrderedSet } from 'immutable';
import { getTrackName } from './trackSelectors';
import { getLessonName } from './lessonSelectors';
export const getFavoriteedItems = state => {
  return state.favorites.favorites || OrderedSet();
};
export const getCumulativeFavoriteedItems = state => {
  return state.favorites.cumulativeFavorites || OrderedSet();
};
export const getAreFavoritesRequesting = state => {
  return !!state.favorites.isGetFavoritesRequesting;
};
export const getIsFavoriteRequesting = (state, {
  trackId,
  lessonId
}) => {
  return !!(state.favorites.isGetFavoritesRequesting || state.favorites.isFavoriteEditRequesting.getIn([lessonId ? 'lessons' : 'tracks', lessonId || trackId]));
};
export const getIsFavoriteSet = (state, {
  trackId,
  lessonId
}) => {
  const favorites = getFavoriteedItems(state);
  return favorites.find(favorite => {
    return lessonId ? parseInt(favorite.get('lessonId'), 10) === lessonId : parseInt(favorite.get('trackId'), 10) === trackId;
  });
};
export const getNewFavouriteName = state => {
  const lessonId = state.favoritesTooltip.newFavouriteLessonId;
  const trackId = state.favoritesTooltip.newFavouriteTrackId;
  const removedLessonId = state.favoritesTooltip.removedFavouriteLessonId;
  const removedTrackId = state.favoritesTooltip.removedFavouriteTrackId;
  let title = '';
  let added = true;
  if (trackId) {
    title = getTrackName(state, {
      trackId
    });
  }
  if (lessonId) {
    title = getLessonName(state, {
      lessonId
    });
  }
  if (removedTrackId) {
    added = false;
    title = getTrackName(state, {
      trackId: removedTrackId
    });
  }
  if (removedLessonId) {
    added = false;
    title = getLessonName(state, {
      lessonId: removedLessonId
    });
  }
  return {
    title,
    added
  };
};